import { t } from '../../config/translations';

export type ArticleType =
  | 'VESTE CUISIN'
  | 'VESTE COSTU'
  | 'PANTALON'
  | 'CHEMISE'
  | 'CHAUSSURES';

export type ReturnReason = 'GRAND' | 'PETIT';

type ArticleTypeKey =
  | 'vesteCuisin'
  | 'vesteCostu'
  | 'pantalon'
  | 'chemise'
  | 'chaussures';
type ReturnReasonKey = 'grand' | 'petit';

// Mapping from ArticleType to translation key prefix
const articleTypeKeyMap: Record<ArticleType, ArticleTypeKey> = {
  'VESTE CUISIN': 'vesteCuisin',
  'VESTE COSTU': 'vesteCostu',
  PANTALON: 'pantalon',
  CHEMISE: 'chemise',
  CHAUSSURES: 'chaussures',
};

// Mapping from ReturnReason to translation key
const returnReasonKeyMap: Record<ReturnReason, ReturnReasonKey> = {
  GRAND: 'grand',
  PETIT: 'petit',
};

// Define the advice keys for each article type and return reason
const adviceKeysConfig: Record<ArticleTypeKey, Record<ReturnReasonKey, string[]>> = {
  vesteCuisin: {
    grand: ['sleeveLength', 'jacketTooLong', 'jacketTooWide'],
    petit: ['sleeveLength', 'jacketTooShort', 'jacketTooTightHips'],
  },
  vesteCostu: {
    grand: ['sleeveLength', 'jacketTooLong', 'jacketTooWide'],
    petit: ['sleeveLength', 'jacketTooShort', 'jacketTooTightHips'],
  },
  pantalon: {
    grand: ['legLength', 'legWidth', 'waistSize'],
    petit: ['legLength', 'thighWidth', 'waistSize'],
  },
  chemise: {
    grand: ['neckSize', 'sleevesTooLong', 'shirtLength'],
    petit: ['neckSize', 'sleevesTooShort', 'shirtLength'],
  },
  chaussures: {
    grand: ['shoeTooBig'],
    petit: ['shoeTooSmall'],
  },
};

const searchArticleType = (productName: string): ArticleType | undefined => {
  const articleTypes: ArticleType[] = [
    'VESTE CUISIN',
    'VESTE COSTU',
    'PANTALON',
    'CHEMISE',
    'CHAUSSURES',
  ];

  return articleTypes.find((articleType) => {
    const regex = new RegExp(articleType.split(' ').join('\\s*'), 'i');
    return regex.test(productName.toUpperCase());
  });
};

const returnDisclaimerContent = (
  articleType: ArticleType,
  returnReason: ReturnReason,
) => {
  const articleKey = articleTypeKeyMap[articleType];
  const reasonKey = returnReasonKeyMap[returnReason];
  const adviceKeys = adviceKeysConfig[articleKey][reasonKey];

  // Build advice array from translations
  const advice = adviceKeys.map((adviceKey) => {
    const titleKey = `disclaimer.${articleKey}.${reasonKey}.${adviceKey}.title` as const;
    const contentKey =
      `disclaimer.${articleKey}.${reasonKey}.${adviceKey}.content` as const;

    return {
      // @ts-expect-error - Dynamic key access for translations
      [t(titleKey)]: t(contentKey),
    };
  });

  // Get localized return reason
  const returnReasonKey =
    returnReason === 'GRAND'
      ? 'disclaimer.returnReason.tooBig'
      : 'disclaimer.returnReason.tooSmall';

  return {
    articleType,
    returnReason: t(returnReasonKey),
    advice,
  };
};

export { returnDisclaimerContent, searchArticleType };
